import { render } from "./Regional.vue?vue&type=template&id=1b4830df"
import script from "./Regional.vue?vue&type=script&lang=js"
export * from "./Regional.vue?vue&type=script&lang=js"

import "./Regional.vue?vue&type=style&index=0&id=1b4830df&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__